import {
  FormAuditLogTable,
  type FormAuditLogTab,
} from 'src/components/organisms/FormAuditLogTable';
import { ArchiveFormConfirmModal } from './ArchiveFormConfirmModal';
import { DeleteDraftConfirmModal } from './DeleteDraftConfirmModal';
import { DuplicateFormModal } from './DuplicateFormModal';
import { UnpublishFormConfirmModal } from './UnpublishFormConfirmModal';
import type { FormData } from './types';
import { FormType } from './types';

export type CoiFormManagementModalsProps = {
  formToDuplicate: FormData | null;
  setFormToDuplicate: (form: FormData | null) => void;
  onDuplicateConfirm: (
    mode: 'all-languages' | 'default-only',
    newTitle: string,
  ) => void;
  formToArchive: FormData | null;
  setFormToArchive: (form: FormData | null) => void;
  onArchiveConfirm: () => void;
  formToUnpublish: FormData | null;
  setFormToUnpublish: (form: FormData | null) => void;
  onUnpublishConfirm: () => void;
  unpublishMutationLoading: boolean;
  formToDelete: FormData | null;
  setFormToDelete: (form: FormData | null) => void;
  onDeleteConfirm: () => void;
  deleteMutationLoading: boolean;
  auditLogOpen: boolean;
  setAuditLogOpen: (open: boolean) => void;
  setAuditLogForm: (form: FormData | null) => void;
  auditLogEnabledTabs: readonly FormAuditLogTab[];
  auditLogCategoryIdMap: Partial<Record<FormAuditLogTab, string>>;
  auditLogForm: FormData | null;
};

export function CoiFormManagementModals({
  formToDuplicate,
  setFormToDuplicate,
  onDuplicateConfirm,
  formToArchive,
  setFormToArchive,
  onArchiveConfirm,
  formToUnpublish,
  setFormToUnpublish,
  onUnpublishConfirm,
  unpublishMutationLoading,
  formToDelete,
  setFormToDelete,
  onDeleteConfirm,
  deleteMutationLoading,
  auditLogOpen,
  setAuditLogOpen,
  setAuditLogForm,
  auditLogEnabledTabs,
  auditLogCategoryIdMap,
  auditLogForm,
}: CoiFormManagementModalsProps) {
  return (
    <>
      <DuplicateFormModal
        open={formToDuplicate != null}
        setOpen={(open) => !open && setFormToDuplicate(null)}
        onConfirm={onDuplicateConfirm}
        isLoading={false}
        formType={formToDuplicate?.type ?? FormType.CONFLICT_OF_INTEREST}
        data-testid="duplicate-form-modal"
      />
      <ArchiveFormConfirmModal
        open={!!formToArchive}
        setOpen={(open) => !open && setFormToArchive(null)}
        onConfirm={onArchiveConfirm}
        onCancel={() => setFormToArchive(null)}
        data-testid="archive-form-confirm-modal"
      />
      <UnpublishFormConfirmModal
        open={!!formToUnpublish}
        setOpen={(open) => !open && setFormToUnpublish(null)}
        onConfirm={onUnpublishConfirm}
        onCancel={() => setFormToUnpublish(null)}
        isLoading={unpublishMutationLoading}
        formTitle={formToUnpublish?.title}
        data-testid="unpublish-form-confirm-modal"
      />
      <DeleteDraftConfirmModal
        open={!!formToDelete}
        setOpen={(open) => !open && setFormToDelete(null)}
        onConfirm={onDeleteConfirm}
        onCancel={() => setFormToDelete(null)}
        isLoading={deleteMutationLoading}
        formTitle={formToDelete?.title}
        data-testid="delete-draft-confirm-modal"
      />
      <FormAuditLogTable
        isOpen={auditLogOpen}
        setIsOpen={(open) => {
          setAuditLogOpen(open);
          if (!open) setAuditLogForm(null);
        }}
        enabledTabs={[...auditLogEnabledTabs]}
        categoryIdMap={auditLogCategoryIdMap}
        questionnaireId={auditLogForm?.id}
        questionnaireTitle={auditLogForm?.title}
      />
    </>
  );
}
